import { CommonAdapter as CoreCommonAdapter } from '@core/adapters';

export class CommonAdapter extends CoreCommonAdapter {}
